export enum DnDMode {
  StartEdge = "start_edge",
  EndEdge = "end_edge",
  Horizontal = "horizontal",
  HorizontalVertical = "horizontal_vertical"
}
